import { render, staticRenderFns } from "./TasksEditor.vue?vue&type=template&id=238d9b46"
import script from "./TasksEditor.vue?vue&type=script&lang=js"
export * from "./TasksEditor.vue?vue&type=script&lang=js"
import style0 from "./TasksEditor.vue?vue&type=style&index=0&id=238d9b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports